<template>
    <div class="cloud-import">
        <CloudImportLog
            :rows="validatedLogs"
            :isStaticSummary="true"
            :summary="summary"
            :mode="mode"
            @onLazyload="onLazyload"
            @onSearch="onSearch"
            @onChangeMode="onChangeMode"
        />
    </div>
</template>

<script>
import CloudImportLog from "@/components/CloudImport/CloudImportLog.vue";
import ServiceCloudImport from "@/services/ServicesCloudImport/ServiceCloudImport";
export default {
	name: "PageCloudImportLog",
	components: {
        CloudImportLog
	},
    /**
     * Входные данные компонента
     */
    props: {
        taskId: {
            type: Number,
            default: 0
        }
    },
	data() {
		return {
            validatedLogs: [],
            summary: {},
            filterParams: {},
            page: null,
            pageCount: null,
            mode: 'uploaded'
		}
	},
	computed: {

	},
    beforeMount() {
        this.page = 1;
    },
    created() {

	},
	methods: {
        onLazyload(){
            if(this.page < this.pageCount){
                this.page++;
            }
        },

        onSearch(value) {
            this.page = null;
            this.filterParams = value;
        },

        onChangeMode(mode){
            this.mode = mode;
            this.page = null;
        }
	},
	watch: {
        page() {
            if(this.page === null){
                this.validatedLogs = [];
                this.page = 1;
                return;
            }

            ServiceCloudImport.logSideList(this.taskId, this.mode, this.page, this.filterParams, (result) => {
                const {pageCount = 0, items = [], summary = {}} = result;
                this.validatedLogs = [...this.validatedLogs, ...items];
                this.pageCount = pageCount;
                this.summary = summary;
                }, () => {}
            );
        }
	}
}
</script>

<style lang="scss" scoped>
.cloud-import {
    overflow-y: auto;
    padding: 20px;
}
</style>
